<template>
  <div class="hello flex">
    <volLeft></volLeft>
    <!-- 志愿列表 -->
    <div class="right" v-show="add">
      <div class="add" @click="addnew">
        添加新志愿
      </div>
      <el-table :data="record" stripe border style="width: 100%;margin-top: 40px;">
        <el-table-column prop="create_time" label="创建时间">
        </el-table-column>
        <el-table-column prop="batch_name" label="批次">
        </el-table-column>
        <el-table-column prop="enroll_type" label="科目">
        </el-table-column>
        <el-table-column prop="score" label="分数">
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <span style="color:#C10B17;cursor: pointer;margin-right: 20px;" @click="editor(scope.row)">
              编辑
            </span>
            <span style="color: #C10B17;cursor: pointer;margin-right: 20px;" @click="goDetail(scope.row)">
              查看
            </span>
            <span @click=" del(scope.row)" style="cursor: pointer;">
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>


    <!-- 确认填报信息弹窗 -->
    <div id="mask" ref="mask" v-show="dialogTableVisible1">
      <div class="confirm">
        <i class="el-icon-close" style="position: absolute;top:
        0;" @click="dialogTableVisible1=false"></i>
        <div class="form1">
          <div class="flex" v-for="(item,index) in set">
            <p style="width:100px">{{item.name}}：</p>
            <el-select v-model="setList[item.key]" :placeholder="item.default"
              style="width: 300px;display: inline-block;">
              <el-option v-for="item in item.list" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="sureSet" @click="setover">
          确认填报
        </div>
      </div>
    </div>

    <!-- 学校内专业历史录取   填报学校内专业-->

    <!-- 专业招生计划 -->
    <plan :data="zhuanyeplan"> </plan>
  </div>
</template>

<script>
  import plan from '../../components/zhaoshengplan.vue'
  import popup from '../../components/popup.vue'
  import schoolFilter from '../../components/schoolfilter.vue'
  import volLeft from '../../components/volLeft.vue'
  import customSelect from '../../components/customSelect.vue'
  export default {
    data() {
      return {
        setList: {
          province_id: '',
          batch: '',
          type: '',
          is_211: '',
        },
        zhuanye_total: 0,
        dataForm: [],
        add: true,
        record: [],
        popupshow: false,
        tabindex: 0,
        formInline: {
          user: '',
          region: ''
        },
        data: [],
        page: 1,
        current: 0,
        activeName: 'first',
        dialogTableVisible: false,
        dialogTableVisible1: false,
        radio: 2,
        userInfo: [],
        options: [],
        batch: '',
        cache_id: '',
        loading: false,
        school_id: '',
        school_pos: '',
        school: [],
        tableData: [],
        tableList: [],
        checkedSchool: [],
        popover_content: '说明',
        zhuanye: [],
        checkedSchool: [],
        checkedId: [],
        old: [], //最开始的数据
        one_major: [],
        tabsConf: [{
            title: '院校优先'
          },
          {
            title: '专业优先'
          }
        ],
        tabType: [{
            value: 'danger',
            label: '冲'
          },
          {
            value: 'safe',
            label: '稳'
          },
          {
            value: 'guarantee',
            label: '保'
          }
        ],
        queryParams: {
          active: 0
        },
        set: [],
        zhuanyeplan: [],
        score: '',
        tip: '',
        popover: false,
        zhuanye_page: 1,
        mode: 'danger',
        batch: ''
      }
    },
    components: {
      popup,
      schoolFilter,
      volLeft,
      customSelect,
      plan
    },
    created() {

      this.$http.customCheckList({
        from_type: 2
      }).then(res => {
        this.record = res.data.list
      })
      this.$http.checkSchoolSimulated().then(res => {
        this.batch = res.data.list[0].name
      })
    },
    methods: {
      goDetail(item) {
        this.$router.push(`/ai?id=${item.id}&batch=${item.batch_name}`)
      },
      cellStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex == 5) {
          //字体颜色
          return "color:red";

        }

      },
      changeschool(item, index) {

        this.$router.push(`/aiChange?cache_id=${this.cache_id}&mode=${item.check_result}&change_id=${index}`)
      },
      /* 保存设置的条件生成志愿*/
      setover() {
        if (this.setList.batch == '') {
          this.setList.batch_name = this.batch
        } else {
          this.setList.batch_name = this.setList.batch
        }

        this.$http.aiIntentionMake(this.setList).then(res => {
          if (res.code == 200) {

            this.$router.push(`/ai?id=${res.data.intention_id}`)
          }

        })
      },
      tabsChange(row, rowIndex) {
        this.queryParams.active = rowIndex
      },
      /* 保存志愿，获取结果*/
      saveAll() {
        this.$http.checkSchool({
          cache_id: this.cache_id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功')
            this.$router.push(`/form?id=${this.cache_id}`)
            localStorage.setItem('activeurl', '/form')
          }
        })
      },
      editor(item) {

        this.$router.push(`/artificial?id=${item.id}&batch=${item.batch_name}&type=ai`)

      },
      del(item) {

        this.$http.intentionDelete({
          id: item.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.$http.customCheckList({
              from_type: 2
            }).then(res => {
              this.record = res.data.list
            })
          }
        })
      },
      /* 添加新志愿*/
      addnew() {
        this.add = true
        this.dialogTableVisible1 = true
        // this.$http.aiSchoolAsk().then(res => {
        //   this.cache_id = res.data.cache_id
        //   this.data = res.data.list
        // })
        this.$http.aiSchoolSet().then(res => {
          this.set = res.data
        })
      },
      /* 筛选学校*/
      filter(e) {

        /* 地区*/
        if (e.num == 1) {
          if (e.diqu.length == 0) {
            this.data = this.old
            return
          }
          let result = []
          for (let i = 0; i < e.diqu.length; i++) {
            for (let o = 0; o < this.old.length; o++) {

              if (e.diqu[i] == this.old[o].province_id) {
                result.push(this.old[o])
              }
            }
          }
          this.data = result

        }
        /* 办学类型 公办民办*/
        if (e.num == 2) {
          if (e.type == '') {
            this.data = this.old
            return
          } else {
            this.data = this.data.filter(item => {

              return item.type == e.type
            })
          }
        }
        /* 985*/
        if (e.num == 3) {
          if (e.is985 == '') {
            this.data = this.old
            return
          } else {
            this.data = this.data.filter(item => {

              return item.is_985 == e.is985
            })
          }
        }
        if (e.num == 4) {
          if (e.is211 == '') {
            this.data = this.old
            return
          } else {
            this.data = this.data.filter(item => {

              return item.is_211 == e.is211
            })
          }
        }
      },
      /* 搜索学校*/
      searchSchool(e) {
        this.$http.checkSchoolCustomSearch({
          cache_id: this.cache_id,
          name: e
        }).then(res => {
          this.data = res.data.list
        })
      },
      /* 清空搜索条件*/
      clear() {
        this.data = this.old
      },
      /* 保存选完专业的学校*/
      savezhuanye() {
        // let result = this.tableList.filter(item => {
        //   return item.checked == true
        // })
        let data = {
          major: this.one_major,
          school_pos: this.school_pos,
          cache_id: this.cache_id
        }
        if (this.zhuanye.length > 5) {
          this.$message.error('最多可填5个专业!')
          return
        }
        this.one_major = []
        this.$http.aiMajorChange(data).then(res => {
          if (res.code == 200) {
            this.$message.success('保存成功!')
            this.popupshow = false
            this.tableList = []
            this.tableData = []
            setTimeout(() => {
              this.$http.aiSchoolAsk({
                cache_id: this.cache_id
              }).then(res => {
                this.data = res.data
                this.data.list.forEach(item => {
                  item.history.unshift({
                    'score_actual': item.score_actual,
                    'score_add_avg': item.score_add_avg,
                    'score_add_div': item.score_add_div,
                    'score_pre_div': item.score_pre_div,
                    'year': item.year,
                    "province_line": item.province_line,
                    'score_rank': item.score_rank,
                    'enroll_plan': item.enroll_plan
                  })
                })
              })
            })
          }
        })
        // this.$http.customCheckDetail({
        //   cache_id: this.cache_id
        // }).then(res => {
        //   this.checkedSchool = res.data.result
        //   this.$forceUpdate()
        // })
      },
      // 点击选择专业
      tianbaozhuanye(item) {
        if (this.zhuanye.indexOf(item.mid + '') > -1) {
          this.zhuanye.splice(this.zhuanye.indexOf((item.mid + '')), 1)
          this.one_major.splice(this.zhuanye.indexOf((item.mid + '')), 1)
        } else {
          if (this.zhuanye.length == 5 && item.checked == false) {
            this.$message.error('最多只能填写五个专业！')
            return
          }
          this.lookplan(item, 2)
          // this.zhuanye.push(item.mid + '')
          // this.one_major.push(item)
          // console.log(this.one_major)
          // console.log(this.zhuanye)
        }
        // this.$forceUpdate()
      },
      surezhuanye(item) {
        // if (this.zhuanye.length == 5 && item.checked == false) {
        //   this.$message.error('最多只能填写五个专业！')
        //   return
        // }
        this.zhuanye.push(item.mid + '')
        this.one_major.push(item)
        item.visible = false
      },
      //查看招生计划
      lookplan(item, num) {
        this.popover_content = ''
        this.tip = ''
        this.$http.schoolEnrollPlan({
          major_name: item.major_name,
          school_id: this.school_id
        }).then(res => {
          console.log(num)
          if (num == 2) {
            item.visible = true
          } else {
            item.visible1 = true
          }

          if (res.data.list.length == 0) {
            this.popover_content = '暂无专业详情'
            return
          }
          if (res.data.list[0].enroll_limit == true) {
            this.tip = `此专业有报考限制条件，请注意查看说明---`
            this.popover_content = `此专业有报考限制条件，请注意查看说明---` + res.data.list[0].year + res.data.list[0].major_name +
              ';    招生人数:' + res.data.list[
                0]
              .num + '   费用:' + res.data.list[0].money_year +
              '    说明:' + res.data.list[0].major_detail
          } else {
            this.popover_content = res.data.list[0].year + res.data.list[0].major_name +
              ';    招生人数:' + res.data.list[
                0]
              .num + '   费用:' + res.data.list[0].money_year +
              '    说明:' + res.data.list[0].major_detail
          }
          // this.popover = true
        })
      },
      /* 切换专业历史录取的年份 */
      tabchange(item, index) {
        this.mode = item.value
        this.zhuanye_page = 1
        this.tableList = []
        let data = {
          cache_id: this.cache_id,
          school_pos: this.school_pos,
          mode: item.value
        }
        this.$http.aiMajorList(data).then(res => {
          this.tableData = res.data
          this.zhuanye_total = res.data.total
          if (res.data.list.length != 0) {
            res.data.list.forEach(item => {
              item.checked = false
            })
          }
          this.tableList = res.data.list
          this.tabindex = index
          this.popupshow = true
        })
      },
      /* 点击填报学校*/
      tianbao(item, index) {
        this.tabindex = 0
        this.zhuanye = item.major_list.map(item1 => {
          return item1.mid
        })
        this.one_major = item.major_list
        this.school_id = item.school_id
        this.school = item
        this.school_pos = index
        let data = {
          cache_id: this.cache_id,
          school_pos: index,
          mode: this.mode,
          page: this.zhuanye_page,
          per: 10
        }
        this.$http.aiMajorList(data).then(res => {
          this.tableData = res.data
          this.zhuanye_total = res.data.total
          // if (res.data.list.length != 0) {
          //   res.data.list.forEach(item => {
          //     item.checked = false
          //   })
          // }
          this.tableList = res.data.list
          this.popupshow = true
        })
      },
      current_change(e) {
        this.zhuanye_page = e
        let data = {
          cache_id: this.cache_id,
          school_pos: this.school_pos,
          mode: this.mode,
          page: this.zhuanye_page,
          per: 10
        }
        this.$http.aiMajorList(data).then(res => {
          this.tableData = res.data
          this.zhuanye_total = res.data.total
          this.tableList = res.data.list
          this.popupshow = true
        })
      },
      change() {
        this.dialogTableVisible = true
      },
      check(item) {
        this.batch = item.name
        this.options.forEach(item1 => {
          item1.checked = false
        })
        item.checked = true
      },
      sure() {
        if (this.batch == '') {
          this.$message.warning('请先选择批次')
          return
        }
        this.$http.customSchoolNew({
          batch: this.batch
        }).then(res => {
          this.cache_id = res.data.cache_id
          this.dialogTableVisible1 = false
          this.add = false
          this.$http.checkSchoolCustomSearch({
            cache_id: this.cache_id
          }).then(res => {
            this.data = res.data.list
            this.old = res.data.list
            this.data.forEach(item => {
              item.checked = false
            })
          })
          this.$http.customCheckDetail({
            cache_id: this.cache_id
          }).then(res => {
            this.school_pos = res.data.result.length
            this.checkedSchool = this.data.map(item => {
              return item.school_id
            })
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .lei {
    width: 30px;
    height: 30px;
    display: inline-block;

    border: 1px solid #FF0000;
    color: #ffffff;
    border-radius: 5px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;
    background-color: #FF0000;
  }

  .lei1 {
    width: 30px;
    height: 30px;
    display: inline-block;
    border: 1px solid #FFBD09;
    color: #ffffff;
    border-radius: 5px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;
    background-color: #FFBD09;
  }

  .lei2 {
    width: 30px;
    height: 30px;
    display: inline-block;
    border-radius: 5px;
    border: 1px solid #19CACA;
    color: #ffffff;

    font-size: 14px;
    text-align: center;
    line-height: 30px;
    background-color: #19CACA;
  }

  .tabs {
    margin-top: 18px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .sureSet {
    width: 378px;
    height: 44px;
    background: #19CACA;
    border-radius: 4px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 44px;
    margin: 0 auto 20px auto;
    cursor: pointer;
  }

  .form1 {
    width: 80%;
    text-align: left;
    margin-top: 20px;
    margin: 40px auto 10px auto;

    .flex {
      // border-bottom: 1px solid #cecece;
      padding-bottom: 20px;
    }

    .formone {
      width: 479px;
      height: 45px;
      background: #FFFFFF;
      // border: 1px solid #E6E6E6;
      border-radius: 4px;
      margin: 18px auto;
      justify-content: space-between;

      &>div {
        margin-left: 10px;
      }
    }
  }

  .tabs-item {
    width: 200px;
    height: 100%;
    font-size: 14px;
    color: #242526;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .tabs-active {
    color: #19CACA;
    font-weight: 600;
    padding-bottom: 10px;
    border-bottom: 3px solid #19CACA;
  }

  .tabs-line {
    flex: 1;
    height: 2px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    background-color: #19CACA;
  }

  .add {
    width: 980px;
    height: 50px;
    line-height: 50px;
    background: #C10B17;
    border: 1px solid #C10B17;
    border-radius: 4px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }

  .batch {
    image {
      width: 28px !important;
      height: 22px;
    }

    .listone1 {
      margin: 10px 44px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 22px;
      text-align: left;

      text {
        font-size: 16px;
        color: #797373 !important;
        margin-right: 19px;
      }

      image {
        width: 14px;
        height: 25px;
      }

      .left1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-top: 14px;
      }

      .left2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 19px 0 15px 0;
      }

      .left3 {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #19CACA;
      }
    }
  }

  .confirm {
    width: 558px;
    // height: 456px;
    background: #FFFFFF;
    border-radius: 10px;
    z-index: 1000;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -350px;

    i {
      right: 20px;
      top: 10px;
    }

    button {
      width: 100px;
      height: 40px;
      background: #19CACA;
      border-radius: 20px;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .right_tip {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .form>div {
      margin-bottom: 34px;
      position: relative;

      span {
        width: 64px;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .form input {
      width: 387px;
      height: 41px;
      border: 1px solid #E6E6E6;
      border-radius: 20px;
      outline: none;
      margin-left: 38px;
      text-indent: 23px;
    }

    .head {
      margin: 47px 77px 44px 70px;

      span {
        display: inline-block;
        width: 50%;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
      }
    }
  }

  .form {
    // padding-bottom: 40px;
  }

  .sure {
    width: 299px !important;
    height: 40px;
    background: #19CACA;
    border-radius: 20px;
    margin-top: 27px;
  }

  .selected {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333 !important;
  }

  .current {
    width: 324px;
    height: 39px;
    line-height: 39px;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #FA6002;
    text-align: left;

    & span:nth-child(1) {
      background-color: #19CACA;
    }

    span {
      display: inline-block;
      text-align: center;
    }

    .dangqian {
      width: 236px;
    }

    .change {
      display: inline-block;
      width: 81px;
      height: 39px;
      background: #FF6500;
      border-radius: 10px;
      color: #ffffff;
    }
  }

  #mask {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 998;
    height: 100vh;
  }

  .tablemain {
    min-height: 135px;

    &>div {
      // flex: 1;
      text-align: center;
    }

    border-bottom: 1px solid #F2F2F2;
    padding: 18px 0;

    .shuju span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: rgba(207, 202, 204, 0.1);
      border: 1px solid #B0B0B0;
      color: #B0B0B0;
      border-radius: 5px;
    }

    .shuju1 span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border: 1px solid transparent;
      text-align: center;
      border-radius: 5px;
    }

    .btn {
      width: 74px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      background: #19CACA;
      border-radius: 4px;
      margin: 10px 0;
    }

    .info {

      text-align: center;

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 15px;
      }
    }
  }

  .tablehead {
    // width: 1009px;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;

    span {
      display: inline-block;
      // flex: 1;
      text-align: center;
    }

    & span:nth-child(2) {
      // flex: 3
    }

    & span:nth-child(3) {
      // flex: 2
    }
  }

  main {
    margin-top: 51px;

    .choosetype {
      text-align: left;

      .active {
        font-weight: 400;
        color: #19CACA;
        background: #D1F4F4;
      }

      span {
        display: inline-block;
        width: 107px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 0px 0px 0px;
        border: 1px solid #F2F2F2;
        border-radius: 4px 0px 0px 0px;
        text-align: center;
      }
    }
  }


  .right {
    margin-left: 16px;
  }

  .tip {
    text-align: left;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #19CACA
  }

  .line {
    margin: 25px 0 18px 0;
    color: #19CACA
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #19CACA;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #19CACA;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .change {
    width: 205px;
    height: 151px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .active {
    background: #19CACA;
    color: #FFFFFF;
  }

  .tabactive {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #19CACA;
    border-bottom: 1px solid #19CACA;
  }

  .type {
    margin-top: 22px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;
    line-height: 20px;

    span {
      // margin: 0 5px;
    }
  }

  .name {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .address {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    // margin-left: 10px;
  }

  .popuptitle {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #E6E6E6;
    text-indent: 40px;
  }

  .popup2 {
    width: 800px;
    height: 654px;
    background: #e8ffc9;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -327px;
    overflow: hidden;
  }

  .caozuo {
    margin-top: 30px;
  }

  .popuphead {
    width: 100%;
    line-height: 40px;
    height: 40px;
    border-bottom: 1px solid #E6E6E6;
    justify-content: space-between;

    p {
      margin-left: 20px;
    }

    i {
      margin-right: 20px;
    }
  }

  .popup1 {
    width: 1100px;
    padding-bottom: 40px;
    background: #ffffff;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -495px;
    margin-top: -327px;
    overflow: hidden;
    z-index: 999;
  }

  .tableHead1 {
    width: 1000px;
    margin: 0 auto;
    height: 40px;
    background: #FAFAFA;
    border-radius: 4px;
    line-height: 40px;

  }

  .tableHead1 span {
    width: 120px;
    color: #999999;
  }

  .table1 {
    width: 100%;
    justify-content: space-around;
    margin-top: 30px;
    position: relative;

    i {
      top: -10px;
      right: 15px;
    }

    .tip {
      color: #666666;
      text-align: left;
      margin: 10px 30px;
    }
  }

  .tableHead {
    margin-top: 40px;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/volunteer/aiList.vue